import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

export function useAuthProfile() {
    const { keycloak } = useKeycloak();
    const [profile, setProfile] = useState<unknown>();

    useEffect(() => {
        keycloak.loadUserProfile().then(value => {
            setProfile(value);
        });
    }, [keycloak, profile]);

    return profile;
}

export function useOidcAuthProfile() {
    const auth = useAuth();
    const [profile, setProfile] = useState<unknown>();

    useEffect(() => {
        if (auth.user) {
            setProfile(auth.user.profile);
        }
    }, [useAuth, profile]);

    return profile;
}
